var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62502 14.6668C6.62502 15.012 6.3452 15.2918 6.00002 15.2918C5.65484 15.2918 5.37502 15.012 5.37502 14.6668L5.37502 6.9585H1.00002C0.747229 6.9585 0.519332 6.80622 0.422594 6.57267C0.325855 6.33913 0.379328 6.0703 0.558077 5.89155L5.55808 0.891554C5.67529 0.774344 5.83426 0.708496 6.00002 0.708496C6.16578 0.708496 6.32475 0.774344 6.44196 0.891554L11.442 5.89155C11.6207 6.0703 11.6742 6.33913 11.5774 6.57267C11.4807 6.80622 11.2528 6.9585 11 6.9585H6.62502L6.62502 14.6668Z",
    fill: "#09CF02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenUpArrow);
export default __webpack_public_path__ + "static/media/greenUpArrow.b26e6caf5095c5bba3f91d9da46d37c9.svg";
export { ForwardRef as ReactComponent };